module.exports = __webpack_public_path__ + "static/scale-model-of-colorado-springs-colorado-d8f79d8582d2506c3624dfb9e2ffd8bd.png";